// import VT from '@/store/types';

export default {
  // [VT.APPS_LIST]: (state, { data, status }) => {
  //   state.passwordsList = { data, status };
  // },
};
